// Voter Awareness Blog Articles - Hindi Version
export const voterAwarenessBlogsHi = [
  {
    id: 1,
    slug: "why-your-vote-matters",
    title: "आपका वोट क्यों मायने रखता है: लोकतंत्र की शक्ति",
    subtitle: "हर वोट बिहार के भविष्य को आकार देने की आवाज है",
    excerpt: "जानें कि आपका वोट सिर्फ एक अधिकार नहीं, बल्कि एक जिम्मेदारी है जो हमारे लोकतंत्र के भविष्य को आकार देती है।",
    category: "मतदाता जागरूकता",
    author: "बिहार चुनाव आयोग",
    readTime: "5 मिनट पढ़ें",
    date: "20 अक्टूबर, 2025",
    featured: true,
    image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800",
    content: `
      <h2>लोकतंत्र की नींव</h2>
      <p>मतदान लोकतंत्र की आधारशिला है। बिहार में 7 करोड़ से अधिक पात्र मतदाताओं के साथ, प्रत्येक वोट में परिवर्तन और प्रगति लाने की अपार शक्ति है। आपका एक वोट आपके निर्वाचन क्षेत्र और पूरे राज्य का भविष्य तय कर सकता है।</p>
      
      <h2>हर वोट क्यों मायने रखता है</h2>
      <ul>
        <li><strong>प्रतिनिधित्व:</strong> आपका वोट सुनिश्चित करता है कि सरकार में आपकी आवाज सुनी जाए</li>
        <li><strong>जवाबदेही:</strong> निर्वाचित प्रतिनिधि आपके प्रति जवाबदेह हैं</li>
        <li><strong>परिवर्तन:</strong> विकास और नीतियों के लिए वोट करें जिनमें आप विश्वास करते हैं</li>
        <li><strong>अधिकार:</strong> हमारे संविधान द्वारा दिए गए मौलिक अधिकार का प्रयोग करें</li>
      </ul>
      
      <h2>ऐतिहासिक प्रभाव</h2>
      <p>बिहार के 2020 के चुनावों में, कई निर्वाचन क्षेत्रों का फैसला 1,000 से कम वोटों के अंतर से हुआ। 2015 में, गया टाउन निर्वाचन क्षेत्र केवल 266 वोटों से जीता गया था। यह साबित करता है कि हर एक वोट मायने रखता है!</p>
      
      <h2>आपका वोट = आपका भविष्य</h2>
      <p>जब आप वोट देते हैं, तो आप केवल एक उम्मीदवार का चयन नहीं कर रहे हैं - आप बिहार में शिक्षा नीतियों, स्वास्थ्य सुविधाओं, बुनियादी ढांचे के विकास और रोजगार के अवसरों पर निर्णय ले रहे हैं। आपका वोट प्रभावित करता है:</p>
      <ul>
        <li>स्कूलों और कॉलेजों की गुणवत्ता</li>
        <li>स्वास्थ्य और चिकित्सा सुविधाएं</li>
        <li>सड़क और परिवहन बुनियादी ढांचा</li>
        <li>रोजगार और व्यापार के अवसर</li>
        <li>आपके क्षेत्र में कानून और व्यवस्था</li>
      </ul>
      
      <blockquote>
        "लोकतंत्र केवल एक दर्शक खेल नहीं है। इसके लिए हर नागरिक की सक्रिय भागीदारी की आवश्यकता है।" - डॉ. बी.आर. अम्बेडकर
      </blockquote>
      
      <h2>अपनी आवाज को गिनें</h2>
      <p>चुनाव के दिन, अपने अधिकार का प्रयोग करें। अपने मतदान केंद्र पर जाएं, अपना वोट डालें, और बिहार और भारत के एक जिम्मेदार नागरिक होने पर गर्व करें!</p>
    `,
    tags: ["लोकतंत्र", "मतदान अधिकार", "बिहार चुनाव", "नागरिक कर्तव्य"]
  },
  {
    id: 2,
    slug: "how-to-vote-step-by-step",
    title: "कैसे वोट करें: पूर्ण चरण-दर-चरण गाइड",
    subtitle: "बिहार में मतदान प्रक्रिया के लिए एक सरल गाइड",
    excerpt: "अपने मतदान केंद्र को खोजने से लेकर सफलतापूर्वक अपना वोट डालने तक की पूरी मतदान प्रक्रिया सीखें।",
    category: "चुनाव प्रक्रिया",
    author: "चुनाव सहायता टीम",
    readTime: "7 मिनट पढ़ें",
    date: "18 अक्टूबर, 2025",
    featured: true,
    image: "https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?w=800",
    content: `
      <h2>चुनाव के दिन से पहले</h2>
      
      <h3>1. अपना पंजीकरण जांचें</h3>
      <p>सत्यापित करें कि आपका नाम मतदाता सूची में है:</p>
      <ul>
        <li>राष्ट्रीय मतदाता सेवा पोर्टल (nvsp.in) पर जाएं</li>
        <li>खोजने के लिए अपना विवरण दर्ज करें</li>
        <li>अपने मतदान केंद्र का स्थान नोट कर लें</li>
      </ul>
      
      <h3>2. अपना मतदाता पहचान पत्र प्राप्त करें</h3>
      <p>मतदान के लिए स्वीकार्य दस्तावेज:</p>
      <ul>
        <li>मतदाता पहचान पत्र (EPIC)</li>
        <li>आधार कार्ड</li>
        <li>पासपोर्ट</li>
        <li>ड्राइविंग लाइसेंस</li>
        <li>पैन कार्ड</li>
        <li>फोटो के साथ सेवा पहचान पत्र</li>
      </ul>
      
      <h2>चुनाव के दिन</h2>
      
      <h3>चरण 1: अपने मतदान केंद्र पर पहुंचें</h3>
      <p>भीड़ से बचने के लिए जल्दी पहुंचें (मतदान सुबह 7 बजे शुरू होता है)। अपना मतदाता पहचान पत्र या स्वीकार्य दस्तावेज लाएं।</p>
      
      <h3>चरण 2: प्रवेश द्वार पर कतार में खड़े हों</h3>
      <p>पुरुषों और महिलाओं के लिए अलग-अलग कतारें। सामाजिक दूरी बनाए रखें और यदि लागू हो तो COVID प्रोटोकॉल का पालन करें।</p>
      
      <h3>चरण 3: दस्तावेज़ सत्यापन</h3>
      <p>मतदान अधिकारी को अपना पहचान पत्र दिखाएं। आपके नाम की मतदाता सूची में पुष्टि की जाएगी।</p>
      
      <h3>चरण 4: स्याही का निशान प्राप्त करें</h3>
      <p>डुप्लिकेट मतदान को रोकने के लिए आपकी बाईं तर्जनी पर अमिट स्याही लगाई जाएगी।</p>
      
      <h3>चरण 5: मतदान कक्ष में प्रवेश करें</h3>
      <p>आपको इलेक्ट्रॉनिक वोटिंग मशीन (EVM) की ओर निर्देशित किया जाएगा।</p>
      
      <h3>चरण 6: अपना वोट डालें</h3>
      <ol>
        <li>बैलेट यूनिट पर उम्मीदवारों की सूची देखें</li>
        <li>अपने चुने हुए उम्मीदवार के बगल में नीले बटन को दबाएं</li>
        <li>लाल लैंप चमकेगा और बीप की आवाज आपके वोट की पुष्टि करेगी</li>
        <li>आप केवल एक बार दबा सकते हैं</li>
      </ol>
      
      <h3>चरण 7: बाहर निकलें और मतदाता पर्ची एकत्र करें</h3>
      <p>भागीदारी के प्रमाण के रूप में बाहर निकलने पर अपनी "मैंने वोट किया" पर्ची एकत्र करें।</p>
      
      <div class="info-box">
        <h4>⏰ मतदान समय</h4>
        <p>सुबह 7:00 बजे से शाम 6:00 बजे तक</p>
        <p>यदि आप शाम 6 बजे कतार में हैं, तो भी आप वोट दे सकते हैं!</p>
      </div>
      
      <h2>महत्वपूर्ण क्या करें और क्या न करें</h2>
      
      <h3>✅ करें:</h3>
      <ul>
        <li>एक वैध पहचान पत्र ले जाएं</li>
        <li>मतदान कक्ष में अकेले जाएं</li>
        <li>अपना फोन साइलेंट रखें</li>
        <li>धैर्य रखें और सम्मानजनक रहें</li>
      </ul>
      
      <h3>❌ न करें:</h3>
      <ul>
        <li>मतदान कक्ष के अंदर मोबाइल फोन न ले जाएं</li>
        <li>अपने वोट की तस्वीर न लें</li>
        <li>मतदान केंद्र के पास प्रचार न करें (100 मीटर के दायरे में प्रतिबंध)</li>
        <li>मतदान अधिकारियों से बहस न करें</li>
      </ul>
      
      <blockquote>
        "आपका वोट आपकी आवाज है। इसे गिनें!"
      </blockquote>
    `,
    tags: ["मतदान गाइड", "EVM", "चुनाव प्रक्रिया", "पहली बार मतदाता"]
  },
  {
    id: 3,
    slug: "first-time-voter-guide",
    title: "पहली बार मतदाता? यहां वह सब कुछ है जो आपको जानना चाहिए",
    subtitle: "बिहार में युवा मतदाताओं के लिए एक व्यापक गाइड",
    excerpt: "पहली बार वोट देने के लिए उत्साहित हैं? पंजीकरण, दस्तावेज और चुनाव के दिन क्या उम्मीद करें, सब कुछ जानें।",
    category: "युवा जागरूकता",
    author: "युवा आउटरीच टीम",
    readTime: "6 मिनट पढ़ें",
    date: "15 अक्टूबर, 2025",
    featured: true,
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800",
    content: `
      <h2>लोकतंत्र में आपका स्वागत है! 🎉</h2>
      <p>वोट देने के योग्य होने पर बधाई! बिहार में पहली बार मतदाता के रूप में, आप लोकतंत्र के सबसे महत्वपूर्ण अधिकारों में से एक का प्रयोग करने जा रहे हैं। यह गाइड आपको आत्मविश्वास के साथ पूरी प्रक्रिया को समझने में मदद करेगी।</p>
      
      <h2>क्या मैं वोट देने के योग्य हूं?</h2>
      <p>आप वोट दे सकते हैं यदि आप:</p>
      <ul>
        <li>योग्यता तिथि पर 18 वर्ष या उससे अधिक आयु के हैं</li>
        <li>भारतीय नागरिक हैं</li>
        <li>बिहार (या अपने निर्वाचन क्षेत्र) के निवासी हैं</li>
        <li>स्वस्थ मन के हैं और अयोग्य नहीं हैं</li>
      </ul>
      
      <h2>मतदाता के रूप में पंजीकरण कैसे करें</h2>
      
      <h3>ऑनलाइन पंजीकरण</h3>
      <ol>
        <li><strong>nvsp.in</strong> या <strong>voters.eci.gov.in</strong> पर जाएं</li>
        <li>"नया मतदाता पंजीकरण" पर क्लिक करें</li>
        <li>ऑनलाइन फॉर्म 6 भरें</li>
        <li>आवश्यक दस्तावेज अपलोड करें:
          <ul>
            <li>आयु प्रमाण (जन्म प्रमाण पत्र/10वीं का प्रमाण पत्र)</li>
            <li>पता प्रमाण (आधार/राशन कार्ड)</li>
            <li>हालिया फोटोग्राफ</li>
          </ul>
        </li>
        <li>फॉर्म सबमिट करें</li>
        <li>ट्रैकिंग के लिए संदर्भ संख्या नोट करें</li>
      </ol>
      
      <h3>ऑफलाइन पंजीकरण</h3>
      <p>भरे हुए फॉर्म 6 और दस्तावेजों के साथ अपने निकटतम चुनावी पंजीकरण कार्यालय या BLO (बूथ स्तर अधिकारी) पर जाएं।</p>
      
      <h2>अपना मतदाता पहचान पत्र समझें</h2>
      <p>आपका मतदाता पहचान पत्र (EPIC - निर्वाचक फोटो पहचान पत्र) में शामिल है:</p>
      <ul>
        <li>आपका नाम और फोटो</li>
        <li>पिता/पति का नाम</li>
        <li>पता</li>
        <li>अद्वितीय मतदाता पहचान संख्या</li>
        <li>मतदान केंद्र विवरण</li>
      </ul>
      
      <h2>मुझे वोट क्यों देना चाहिए?</h2>
      
      <h3>1. अपना भविष्य आकार दें</h3>
      <p>सरकार शिक्षा, नौकरियों, बुनियादी ढांचे पर निर्णय लेती है - सभी सीधे आपके जीवन को प्रभावित करते हैं।</p>
      
      <h3>2. लोकतंत्र का सम्मान करें</h3>
      <p>लाखों लोगों ने इस अधिकार के लिए संघर्ष किया। इसे बर्बाद न होने दें।</p>
      
      <h3>3. नेताओं को जवाबदेह बनाएं</h3>
      <p>आपका वोट बेहतर शासन की मांग करने का सबसे मजबूत उपकरण है।</p>
      
      <h3>4. अपनी पीढ़ी का प्रतिनिधित्व करें</h3>
      <p>युवा मतदाता उपस्थिति मायने रखती है। अपनी पीढ़ी की आवाज सुनाएं!</p>
      
      <h2>चुनाव दिवस चेकलिस्ट 📋</h2>
      
      <div class="checklist">
        <h4>घर से निकलने से पहले:</h4>
        <ul class="task-list">
          <li>✅ मतदाता पहचान पत्र या वैकल्पिक पहचान पत्र</li>
          <li>✅ मतदान केंद्र का स्थान जांचें</li>
          <li>✅ आरामदायक कपड़े पहनें</li>
          <li>✅ पानी की बोतल ले जाएं</li>
          <li>✅ मोबाइल को कार/लॉकर में छोड़ दें (कक्ष के अंदर अनुमति नहीं है)</li>
        </ul>
      </div>
      
      <h2>पहली बार के लिए सामान्य प्रश्न</h2>
      
      <h3>प्रश्न: यदि मेरे पास अभी तक मतदाता पहचान पत्र नहीं है तो क्या होगा?</h3>
      <p>आप आधार, पासपोर्ट, ड्राइविंग लाइसेंस या पैन कार्ड जैसे वैकल्पिक पहचान पत्र के साथ वोट दे सकते हैं।</p>
      
      <h3>प्रश्न: क्या मैं देख सकता हूं कि दूसरे किसे वोट दे रहे हैं?</h3>
      <p>नहीं! मतदान गुप्त है। कोई नहीं जानता कि आपने किसे वोट दिया।</p>
      
      <h3>प्रश्न: यदि मैं मतदान करते समय गलती कर दूं तो क्या होगा?</h3>
      <p>एक बार जब आप बटन दबाते हैं, तो वोट डाल दिया जाता है। दबाने से पहले ध्यान से सोचें!</p>
      
      <h3>प्रश्न: क्या मैं अपने बैलेट के साथ सेल्फी ले सकता हूं?</h3>
      <p>नहीं! मतदान कक्ष में फोन की अनुमति नहीं है। अंदर फोटो लेना अवैध है।</p>
      
      <h2>बदलाव लाएं!</h2>
      <p>पहली बार मतदाता के रूप में, आप दुनिया के सबसे बड़े लोकतंत्र में लाखों भारतीयों के साथ शामिल हो रहे हैं। आपका वोट मायने रखता है, आपकी आवाज मायने रखती है। सिर्फ वोट न दें - अपने दोस्तों और परिवार को भी वोट देने के लिए प्रोत्साहित करें!</p>
      
      <blockquote>
        "आप सिर्फ वोट नहीं दे रहे हैं, आप अपना भविष्य तय कर रहे हैं।" - युवा मतदाता पहल
      </blockquote>
      
      <div class="cta-box">
        <h4>इतिहास रचने के लिए तैयार हैं?</h4>
        <p>अभी पंजीकरण करें | मतदान केंद्र जांचें | मतदाता हेल्पलाइन ऐप डाउनलोड करें</p>
      </div>
    `,
    tags: ["पहली बार मतदाता", "युवा", "मतदाता पंजीकरण", "चुनाव गाइड"]
  },
  {
    id: 4,
    slug: "understanding-democracy",
    title: "लोकतंत्र को समझना: लोगों की शक्ति",
    subtitle: "लोकतंत्र का क्या मतलब है और यह बिहार के लिए क्यों मायने रखता है",
    excerpt: "लोकतांत्रिक सिद्धांतों के बारे में जानें, वे बिहार में कैसे काम करते हैं, और प्रगति के लिए नागरिक भागीदारी क्यों महत्वपूर्ण है।",
    category: "लोकतंत्र शिक्षा",
    author: "नागरिक शिक्षा टीम",
    readTime: "8 मिनट पढ़ें",
    date: "12 अक्टूबर, 2025",
    featured: false,
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800",
    content: `
      <h2>लोकतंत्र क्या है?</h2>
      <p>लोकतंत्र ग्रीक शब्दों "डेमोस" (लोग) और "क्रेटोस" (शक्ति) से आया है, जिसका अर्थ है "लोगों की शक्ति।" भारत 90 करोड़ से अधिक मतदाताओं के साथ दुनिया का सबसे बड़ा लोकतंत्र है।</p>
      
      <h2>भारत में लोकतांत्रिक सिद्धांत</h2>
      
      <h3>1. सार्वभौमिक वयस्क मताधिकार</h3>
      <p>18+ आयु का प्रत्येक नागरिक जाति, धर्म, लिंग या आर्थिक स्थिति की परवाह किए बिना वोट दे सकता है।</p>
      
      <h3>2. स्वतंत्र और निष्पक्ष चुनाव</h3>
      <p>चुनाव आयोग EVMs, आदर्श आचार संहिता और कड़ी निगरानी के माध्यम से निष्पक्ष चुनाव सुनिश्चित करता है।</p>
      
      <h3>3. प्रतिनिधि सरकार</h3>
      <p>आप विधायकों का चुनाव करते हैं जो बिहार विधान सभा में आपके हितों का प्रतिनिधित्व करते हैं।</p>
      
      <h3>4. जवाबदेही</h3>
      <p>निर्वाचित प्रतिनिधियों को नागरिकों के प्रति जवाबदेह होना चाहिए। खराब प्रदर्शन चुनावी हार की ओर ले जाता है।</p>
      
      <h2>बिहार की लोकतांत्रिक यात्रा</h2>
      <p>1952 से, बिहार ने 16 विधानसभा चुनाव देखे हैं। मतदाता उपस्थिति 49% (1952) से बढ़कर 57% (2020) हो गई है, जो बढ़ती लोकतांत्रिक चेतना को दर्शाता है।</p>
      
      <h2>आपका वोट बिहार को कैसे आकार देता है</h2>
      <ul>
        <li><strong>विकास:</strong> सड़कों, बिजली, पानी के लिए प्रतिबद्ध नेताओं को चुनें</li>
        <li><strong>शिक्षा:</strong> बेहतर स्कूल, कॉलेज और कौशल विकास</li>
        <li><strong>स्वास्थ्य:</strong> बेहतर अस्पताल और स्वास्थ्य कार्यक्रम</li>
        <li><strong>रोजगार:</strong> नौकरी सृजन और व्यापार-अनुकूल नीतियां</li>
        <li><strong>सुरक्षा:</strong> कानून और व्यवस्था बनाए रखना</li>
      </ul>
      
      <h2>लोकतंत्र बनाम तानाशाही</h2>
      <table>
        <tr>
          <th>लोकतंत्र (भारत)</th>
          <th>तानाशाही</th>
        </tr>
        <tr>
          <td>लोग नेताओं को चुनते हैं</td>
          <td>नेता सत्ता हथियाता है</td>
        </tr>
        <tr>
          <td>अभिव्यक्ति की स्वतंत्रता</td>
          <td>सेंसरशिप</td>
        </tr>
        <tr>
          <td>नियमित चुनाव</td>
          <td>कोई चुनाव नहीं या नकली चुनाव</td>
        </tr>
        <tr>
          <td>कानून का शासन</td>
          <td>बल द्वारा शासन</td>
        </tr>
      </table>
      
      <h2>आपके अधिकार और कर्तव्य</h2>
      
      <h3>लोकतांत्रिक अधिकार:</h3>
      <ul>
        <li>मतदान का अधिकार</li>
        <li>चुनाव लड़ने का अधिकार</li>
        <li>अभिव्यक्ति की स्वतंत्रता</li>
        <li>सरकार से सवाल करने का अधिकार</li>
      </ul>
      
      <h3>लोकतांत्रिक कर्तव्य:</h3>
      <ul>
        <li>हर चुनाव में वोट दें</li>
        <li>मुद्दों के बारे में जागरूक रहें</li>
        <li>लोकतांत्रिक प्रक्रिया में भाग लें</li>
        <li>दूसरों के राजनीतिक विचारों का सम्मान करें</li>
      </ul>
      
      <blockquote>
        "लोकतंत्र केवल सरकार का एक रूप नहीं है। यह मुख्य रूप से संबद्ध जीवन का एक तरीका है।" - डॉ. बी.आर. अम्बेडकर
      </blockquote>
      
      <h2>बिहार के लोकतंत्र को मजबूत करें</h2>
      <p>हर बार जब आप वोट देते हैं, तो आप लोकतंत्र को मजबूत करते हैं। हर बार जब आप जागरूक रहते हैं, तो आप खुद को सशक्त बनाते हैं। बिहार का भविष्य आप जैसे सक्रिय, जागरूक नागरिकों पर निर्भर करता है!</p>
    `,
    tags: ["लोकतंत्र", "राजनीतिक शिक्षा", "नागरिक कर्तव्य", "बिहार"]
  }
];

export const blogCategoriesHi = [
  "सभी",
  "मतदाता जागरूकता",
  "चुनाव प्रक्रिया",
  "युवा जागरूकता",
  "लोकतंत्र शिक्षा",
  "मतदान अधिकार"
];
